export default __webpack_public_path__ + "static/form-grouping-do-4dd606e127f9d8509386dc0679229b4fa05cb1b86cd528dd22049e24a1af25c8.png";